import { Preferences } from '@capacitor/preferences';
import { isNativePlatform, STORAGE_KEYS } from './storage';

export interface VideoProgress {
  [workshopId: string]: {
    [courseClassesId: string]: {
      currentTime: number;
      duration: number;
      lastSaved: number; // timestamp
    };
  };
}

/**
 * Get video progress from storage
 */
export const getVideoProgress = async (): Promise<VideoProgress> => {
  try {
    if (isNativePlatform()) {
      const { value } = await Preferences.get({ key: STORAGE_KEYS.VIDEO_PROGRESS });
      if (value) {
        try {
          return JSON.parse(value) as VideoProgress;
        } catch (error) {
          console.error('Error parsing video progress:', error);
          return {};
        }
      }
      return {};
    } else {
      const value = localStorage.getItem(STORAGE_KEYS.VIDEO_PROGRESS);
      if (value) {
        try {
          return JSON.parse(value) as VideoProgress;
        } catch (error) {
          console.error('Error parsing video progress:', error);
          return {};
        }
      }
      return {};
    }
  } catch (error) {
    console.error('Error getting video progress:', error);
    return {};
  }
};

/**
 * Set video progress in storage
 */
export const setVideoProgress = async (progress: VideoProgress): Promise<void> => {
  try {
    const value = JSON.stringify(progress);
    if (isNativePlatform()) {
      await Preferences.set({
        key: STORAGE_KEYS.VIDEO_PROGRESS,
        value,
      });
    } else {
      localStorage.setItem(STORAGE_KEYS.VIDEO_PROGRESS, value);
    }
  } catch (error) {
    console.error('Error setting video progress:', error);
  }
};

/**
 * Remove video progress from storage
 */
export const removeVideoProgress = async (): Promise<void> => {
  try {
    if (isNativePlatform()) {
      await Preferences.remove({ key: STORAGE_KEYS.VIDEO_PROGRESS });
    } else {
      localStorage.removeItem(STORAGE_KEYS.VIDEO_PROGRESS);
    }
  } catch (error) {
    console.error('Error removing video progress:', error);
  }
};

/**
 * Synchronous fallback for legacy compatibility
 */
export const getVideoProgressSync = (): VideoProgress => {
  if (typeof window === 'undefined') return {};
  const value = localStorage.getItem(STORAGE_KEYS.VIDEO_PROGRESS);
  if (value) {
    try {
      return JSON.parse(value) as VideoProgress;
    } catch (error) {
      console.error('Error parsing video progress:', error);
      return {};
    }
  }
  return {};
};